export default __webpack_public_path__ + "static/media/marauders-map-v3-05-05.41f27976.jpg";